import { ColumnState } from 'ag-grid-community';

import { FIXED_COL_IDS } from '@/shared/components/ui/data-table/components/ag-grid-table-core/ag-grid-table-core.constants';
import { TStoredColumnState } from '@/shared/types/ui-preferences.types';

// ag-grid reports a dragged width in fractional pixels, and DynamoDB rejects
// floats outright ("Float types are not supported"), failing the whole save.
const toWholePixels = <T extends number | null | undefined>(value: T): T =>
  (typeof value === 'number' ? Math.round(value) : value) as T;

export const toStoredColumnState = (
  state: ColumnState[],
): TStoredColumnState[] =>
  state.map(({ colId, width, flex, sort, sortIndex, hide }) => {
    // Order only: ag-grid pins these widths in code, and omitted properties are
    // left untouched.
    if (FIXED_COL_IDS.includes(colId)) {
      return { colId };
    }

    return {
      colId,
      width: toWholePixels(width),
      flex: toWholePixels(flex),
      sort,
      sortIndex,
      hide,
    };
  });

// applyOrder parks columns missing from the stored state at the far right, so a
// newly shipped column would jump off-screen for anyone holding an older view.
export const canApplyOrder = (
  stored: TStoredColumnState[],
  current: ColumnState[],
): boolean => {
  const storedIds = stored.map(({ colId }) => colId);

  return (
    storedIds.length === current.length &&
    current.every(({ colId }) => storedIds.includes(colId))
  );
};
